/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Step_2Inputs */

const en_svc_rag_step_2 = /** @type {(inputs: Svc_Rag_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare and index them, keeping permissions where people should see different things.`)
};

const lv_svc_rag_step_2 = /** @type {(inputs: Svc_Rag_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavojam un indeksējam tos, saglabājot piekļuves tiesības tur, kur cilvēkiem jāredz atšķirīgi materiāli.`)
};

/**
* | output |
* | --- |
* | "Prepare and index them, keeping permissions where people should see different things." |
*
* @param {Svc_Rag_Step_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_step_2 = /** @type {((inputs?: Svc_Rag_Step_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Step_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_step_2(inputs)
	return en_svc_rag_step_2(inputs)
});